import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

export type DiveTypeToggleProps = {
  value: 'buddy' | 'guided'
  onChange: (value: 'buddy' | 'guided') => void
  guidedDiveFlag: boolean
}

const DiveTypeToggle = ({
  value,
  onChange,
  guidedDiveFlag
}: DiveTypeToggleProps) => {
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newValue: 'buddy' | 'guided' | null
  ) => {
    if (newValue !== null) {
      onChange(newValue)
    }
  }

  return (
    <Box>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        fullWidth
        aria-label='Dive type'
      >
        <ToggleButton value='buddy' aria-label='Buddy dive'>
          Buddy
        </ToggleButton>
        <ToggleButton
          value='guided'
          disabled={!guidedDiveFlag}
          aria-label='Guided dive'
        >
          Guided
        </ToggleButton>
      </ToggleButtonGroup>
      {!guidedDiveFlag && (
        <Typography
          variant='caption'
          color='text.secondary'
          sx={{ mt: 0.5, display: 'block' }}
        >
          Guided dive flag required to create guided dives
        </Typography>
      )}
    </Box>
  )
}

export default DiveTypeToggle
